import React, { Component, PropTypes } from 'react';
import { MediaLibraryOverviewStore } from 'stores';
import { MediaLibraryOverviewActions } from 'actions';
import { getTotal, getVisibleItems } from 'selectors/mediaLibrary';
import { mixin, RefluxMixin } from 'Util';

class MediaLibraryProvider extends mixin(RefluxMixin, Component) {
  static propTypes = {
    children: PropTypes.node
  };

  listenToStores() {
    this.listenToStoreWithMapper(MediaLibraryOverviewStore, state => {
      return {
        items: getVisibleItems(state),
        totalItems: getTotal(state),
        mode: state.mode,
        loading: state.loadng,
        breadCrumbs: state.breadCrumbs,
        ...this.mapActions({
          read: MediaLibraryOverviewActions.read,
          changeDir: MediaLibraryOverviewActions.changeDir,
          gridMode: MediaLibraryOverviewActions.gridMode,
          listMode: MediaLibraryOverviewActions.listMode,
          changeSearchFilter: MediaLibraryOverviewActions.changeSearchFilter
        })
      };
    });
  }

  render() {
    const { children, ...other } = this.props;
    return React.cloneElement(React.Children.only(children), {
      ...children.props,
      ...other,
      ...this.state
    });
  }
}

export default MediaLibraryProvider;



// WEBPACK FOOTER //
// ./src/js/containers/MediaLibrary/MediaLibraryProvider.js